import React, {useMemo, useState, useEffect} from "react";
import cash from "assets/LiveOrders/cash.png";
import card_payment from "assets/LiveOrders/card-payment.png";
import customer1 from "assets/Customerrs/customer1.png";
import Table from "components/molecules/Table";
import TableLayout from "components/molecules/TableLayout";
import {OrderHistoryWrap} from "components/atoms/OrderHistory/OrderHistory.styles";
import OrderHistoryHeader from "components/atoms/OrderHistory/OrderHistoryHeader";
import orderService from "services/orderService";
import {useSelector} from "react-redux";
import {useBusinessContext} from "Context/businessContext";
import Toast from "components/molecules/Toast";
const UserImage = (img, name) => {
    const getInitials = (name) => {
        if (!name) return "?";
        const parts = name.split(' ');
        if (parts.length >= 2) {
            return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    };

    return (
        <div className="textWrap">
            <div className="image-wrapper">
                {img ? (
                    <img src={img} alt="Customer" />
                ) : (
                    <span>{getInitials(name)}</span>
                )}
            </div>
            <p>{name}</p>
        </div>
    );
};

const Payment = (payment_img, payment) => (
    <div className="payment-textWrap">
        <div className="image-wrapper">
            <img src={payment_img} alt="Payment" />
        </div>
        <p>{payment}</p>
    </div>
);

const OrderType = order_type => (
    <div className="Order-textWrap">
        {order_type === "Delivery" || order_type === "delivery" ? (
            <div className="delivery">
                <p>Delivery</p>
            </div>
        ) : order_type === "Pick-up" || order_type === "pickup" ? (
            <div className="pickup">
                <p>Pick-up</p>
            </div>
        ) : null}
    </div>
);

const getPaymentIcon = (paymentMethod) => {
    const method = paymentMethod?.toLowerCase();
    if (method?.includes('cash')) return cash;
    if (method?.includes('card') || method?.includes('credit')) return card_payment;
    return cash; // default
};

const getPaymentLabel = (paymentMethod) => {
    const method = paymentMethod?.toLowerCase();
    if (method?.includes('cash')) return 'Cash';
    if (method?.includes('card') || method?.includes('credit')) return 'Card';
    return paymentMethod || 'Cash';
};
const OrderHistory = () => {
    const businessId = useSelector(state => state.business.businessId);
    const selectedStoreIdFromRedux = useSelector(state => state.business.selectedStoreId);
    const defaultStore = useSelector(state => state.business.defaultStore);
    const {fetch: refetch} = useBusinessContext();
    
    const [searchQuery, setSearchQuery] = useState({
        restaurant: businessId || "",
        store: selectedStoreIdFromRedux || defaultStore || "",
        page: 1,
        itemsPerPage: 10,
        searchText: "",
        startDate: "",
        endDate: "",
        status: "all",
        orderType: "all",
        paymentMethod: "all",
    });

    const [customDateRange, setCustomDateRange] = useState({
        startDate: '',
        endDate: ''
    });

    const [isInitialized, setIsInitialized] = useState(false);

    // Update restaurant and store when they change
    useEffect(() => {
        if (businessId) {
            setSearchQuery(prev => ({
                ...prev,
                restaurant: businessId || "",
                store: selectedStoreIdFromRedux || defaultStore || "",
            }));
            setIsInitialized(true);
        }
    }, [businessId, selectedStoreIdFromRedux, defaultStore]);

    // Fetch order history using the service (only when initialized)
    const {history_loading, history_error, history_data} = orderService.GetOrderHistory(
        isInitialized ? searchQuery : { ...searchQuery, restaurant: "" },
        refetch
    );
    const Status = status => {
        let statusButton = null;
        const statusLower = status?.toLowerCase();

        if (statusLower === "pending" || statusLower === "new_order") {
            statusButton = <button className="pending">Pending</button>;
        } else if (statusLower === "delivered") {
            statusButton = <button className="delivered">Delivered</button>;
        } else if (statusLower === "cancelled" || statusLower === "canceled") {
            statusButton = <button className="canceled">Canceled</button>;
        } else if (statusLower === "completed" || statusLower === "Delivered") {
            statusButton = <button className="completed">Completed</button>;
        } 
         else if (statusLower === "ready_for_pickup" || statusLower === "ready") {
            statusButton = <button className="ready_for_pickup">Ready</button>;
        } 
         else if (statusLower === "accepted") {
            statusButton = <button className="accepted">Accepted</button>;
        } 
         else if (statusLower === "out_for_delivery") {
            statusButton = <button className="out_for_delivery">Out Delivery</button>;
        } 
         else if (statusLower === "preparing") {
            statusButton = <button className="preparing">Preparing</button>;
        } 
        else {
            statusButton = <button className="pending">{status}</button>;
        }
        return <div className="action-btns">{statusButton}</div>;
    };

    // Handle search with debouncing (debounce is in header component)
    const handleSearch = (searchText) => {
        console.log('🔍 Search triggered:', searchText);
        setSearchQuery(prev => ({
            ...prev,
            searchText: searchText || "",
            page: 1, // Reset to first page on search
        }));
    };

    // Handle custom date changes
    const handleCustomDateChange = (field, value) => {
        console.log('📅 Date filter changed:', field, value);
        setCustomDateRange(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // Update search query when custom date range changes
    useEffect(() => {
        // Keep date in yyyy-mm-dd format (ISO format) for the API
        setSearchQuery(prev => ({
            ...prev,
            startDate: customDateRange.startDate || '',
            endDate: customDateRange.endDate || '',
            page: 1,
        }));
    }, [customDateRange]);

    // Handle filter changes
    const handleFilterChange = (filterType, value) => {
        console.log('🔧 Filter changed:', filterType, value);
        setSearchQuery(prev => ({
            ...prev,
            [filterType]: value || "all",
            page: 1, // Reset to first page on filter change
        }));
    };

    // Show error toast if there's an error
    useEffect(() => {
        if (history_error) {
            Toast({
                type: "error",
                message: "Failed to load order history. Please try again."
            });
        }
    }, [history_error]);
    const columnNames = ["Order ID", "Customer Name","Customer Email", "Location", "Type", "Payment", "Status", "Price"];

    const {rowsData, totalCount} = useMemo(() => {
        const orders = history_data?.orders || [];
        
        return {
            rowsData: orders.map(order => {
                // Extract location string from location object
                let locationText = "N/A";
                if (typeof order.location === 'string') {
                    locationText = order.location;
                } else if (order.location && typeof order.location === 'object') {
                    // Location is an object with street_address, city, state, etc.
                    locationText = order.location.street_address || "N/A";
                } else if (order.deliveryAddress) {
                    if (typeof order.deliveryAddress === 'string') {
                        locationText = order.deliveryAddress;
                    } else if (order.deliveryAddress.street_address) {
                        locationText = order.deliveryAddress.street_address;
                    } else if (order.deliveryAddress.street) {
                        locationText = order.deliveryAddress.street;
                    }
                }
                
                // customerAvatar is an object with first_name and phone, not an image URL
                // Use null for avatar image since it's not provided
                const avatarImage = null;
                const customerEmail =  order.customerEmail 
                const customerName = order.customerAvatar?.first_name || "Guest";
                return [
                    order.orderId || order._id,
                    UserImage(avatarImage, customerName),
                    customerEmail ,
                    locationText,
                    OrderType(order.type),
                    Payment(getPaymentIcon(order.paymentMethod), getPaymentLabel(order.paymentMethod)),
                    Status(order.status),
                    `$${order.price || (order.totalAmountInCents / 100).toFixed(2)}`,
                ];
            }),
            totalCount: history_data?.totalItems || 0,
        };
    }, [history_data]);

    // Show loading if not initialized yet
    if (!isInitialized || !businessId) {
        return (
            <>
                <OrderHistoryHeader 
                    totalCount={0}
                    onSearch={handleSearch}
                    onFilterChange={handleFilterChange}
                    filters={searchQuery}
                    customDateRange={customDateRange}
                    onCustomDateChange={handleCustomDateChange}
                />
                <OrderHistoryWrap>
                    <div style={{textAlign: 'center', padding: '40px'}}>
                        <p>Initializing order history...</p>
                    </div>
                </OrderHistoryWrap>
            </>
        );
    }

    return (
        <>
            <OrderHistoryHeader 
                totalCount={totalCount}
                onSearch={handleSearch}
                onFilterChange={handleFilterChange}
                filters={searchQuery}
                customDateRange={customDateRange}
                onCustomDateChange={handleCustomDateChange}
            />
            <OrderHistoryWrap>
                {history_loading ? (
                    <div style={{textAlign: 'center', padding: '40px'}}>
                        <div style={{fontSize: '16px', color: '#666'}}>
                            <div style={{marginBottom: '10px'}}>⏳</div>
                            <p>Loading order history...</p>
                        </div>
                    </div>
                ) : history_error ? (
                    <div style={{textAlign: 'center', padding: '40px'}}>
                        <div style={{color: '#ff4d4f', fontSize: '16px'}}>
                            <div style={{marginBottom: '10px'}}>⚠️</div>
                            <p>Failed to load order history. Please try again.</p>
                            <button 
                                onClick={() => window.location.reload()} 
                                style={{
                                    marginTop: '20px',
                                    padding: '10px 20px',
                                    backgroundColor: '#1890ff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                Retry
                            </button>
                        </div>
                    </div>
                ) : rowsData.length === 0 ? (
                    <div style={{textAlign: 'center', padding: '40px'}}>
                        <div style={{fontSize: '16px', color: '#999'}}>
                            <div style={{marginBottom: '10px'}}>📋</div>
                            <p>No orders found</p>
                            {(searchQuery.searchText || searchQuery.status !== 'all' || searchQuery.orderType !== 'all') && (
                                <p style={{fontSize: '14px', marginTop: '10px'}}>Try adjusting your filters</p>
                            )}
                        </div>
                    </div>
                ) : (
                    <TableLayout
                        onChangeFilters={filters => {
                            console.log('📄 Pagination changed:', filters);
                            setSearchQuery(_ => ({
                                ..._,
                                ...filters,
                            }));
                        }}
                        currentPage={searchQuery?.page}
                        pageSize={searchQuery?.itemsPerPage}
                        totalCount={totalCount}>
                        <Table rowsData={rowsData} columnNames={columnNames} noPadding />
                    </TableLayout>
                )}
            </OrderHistoryWrap>
        </>
    );
};

export default OrderHistory;
